import { render } from "./PersonalPayment.vue?vue&type=template&id=cae5cba4"
import script from "./PersonalPayment.vue?vue&type=script&lang=js"
export * from "./PersonalPayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__